import { ConversationBrainPage } from '../mia-conversation-brain/pages/ConversationBrainPage'

export function LegacyConversationBrainRedirect() {
  return <ConversationBrainPage />
}
